/**
 * @file ContextProviders.js
 * @module src/js/contexts/ContextProviders
 * @description
 * **Composes and wraps multiple global providers into a single component.**
 * - Uses `reduceRight` to nest providers from outermost to innermost.
 * - Returns a component that wraps `children` with all contexts applied.
 * - Simplifies usage by allowing a single `<ContextProviders>` in `index.js`.
 *
 * @version
 * <p>
 *  2025-07-22: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 *  2025-12-02: Added ModalProvider to the context providers. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import { BrowserRouter as Router } from 'react-router-dom';
import ThemeProvider from './ThemeProvider';
import UserProvider from './UserProvider';
import ModalProvider from './ModalProvider';

const composeProviders = (...providers) => ( // this function returns a function
    ({ children }) => providers.reduceRight( // this function returns the nested providers as a component
        (acc, Provider) => <Provider>{acc}</Provider>,
        children
    )
);

const providers = [Router, ThemeProvider, UserProvider, ModalProvider];
const ContextProviders = composeProviders(...providers);

export default ContextProviders;